import React from 'react';
import { useSiteData, DataContextProps } from '@context';

const LegalNavigation = (): JSX.Element | null => {
  const { siteData }: DataContextProps = useSiteData();
  if (siteData) {
    const { translations, currentLocale } = siteData;
    const localeLinkPrefix = currentLocale === 'en' ? '' : `${currentLocale}/`;

    /**
     * Render.
     */
    if (translations) {
      return (
        <div className="legal-navigation">
          <ul>
            <li>
              <a
                href={`https://cancercare.siemens-healthineers.com/${localeLinkPrefix}about-us/legal-information/privacy-notice`}
                target="_blank"
                rel="noreferrer"
              >
                {translations?.privacy_notice}
              </a>
            </li>
            <li className="dot">•</li>
            <li>
              <a
                href={`https://cancercare.siemens-healthineers.com/${localeLinkPrefix}about-us/legal-information`}
                target="_blank"
                rel="noreferrer"
              >
                {translations?.legal_information}
              </a>
            </li>
            <li className="dot">•</li>
            <li>
              <a
                href={`https://cancercare.siemens-healthineers.com/${localeLinkPrefix}about-us/legal-information/copyright-notice-and-trademarks`}
                target="_blank"
                rel="noreferrer"
              >
                {translations?.trademarks}
              </a>
            </li>
            <li className="dot">•</li>
            <li>
              <a
                href="https://www.siemens-healthineers.com/company/compliance"
                target="_blank"
                rel="noreferrer"
              >
                {translations?.code_of_conduct}
              </a>
            </li>
          </ul>
        </div>
      );
    }
  }
  return null;
};

export default LegalNavigation;
